import React from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";

import CustomDatePicker from "../../../../components/shared/date-picker/Date";
import CustomDateTime from "../../../../components/shared/date-picker/Time";
import CalendarIcon from "../../../../components/shared/icons/CalendarIcon";
import ClockIcon from "../../../../components/shared/icons/ClockIcon";

import style from "./TenderDateTimePicker.module.scss";

// Только будущее время (как в OrdersDatePickerTender)
const filterPassedTime = (time) => {
  const selected = new Date(time);
  return new Date().getTime() < selected.getTime();
};

/**
 * Пара полей «Дата окончания тендера» + «Время окончания тендера».
 * Логика повторяет OrdersDatePickerTender:
 *  - при выборе даты время обнуляется, а время окончания по умолчанию ставится на 18:00;
 *  - время выбирается через CustomDateTime с фильтром прошедшего времени.
 */
const TenderDateTimePicker = ({
  date,
  time,
  setDate,
  setTime,
  minDate,
  required = true,
  labelDate,
  labelTime,
  errorDate = "",
  errorTime = "",
  placeholderDate,
  placeholderTime,
}) => {
  const { t } = useTranslation();
  const dateLabel = labelDate || t("bulkCreate.fields.tenderDate");
  const timeLabel = labelTime || t("bulkCreate.fields.tenderTime");
  const datePlaceholder = placeholderDate || t("bulkCreate.placeholders.date");
  const timePlaceholder = placeholderTime || t("bulkCreate.placeholders.time");

  const onChangeDate = (value) => {
    if (!value) {
      setDate(null);
      return;
    }
    const dateWithZeroTime = new Date(value);
    dateWithZeroTime.setHours(0, 0, 0, 0);
    setDate(dateWithZeroTime);

    if (!time) {
      setTime(new Date(new Date(value).setHours(18, 0, 0, 0)));
    }
  };

  return (
    <div className={style.row}>
      <div className={style.col}>
        <span className={style.label}>
          {dateLabel}
          {required && <span className={style.required}> *</span>}
        </span>
        <div className={cn(style.control, { [style.controlError]: errorDate })}>
          <CalendarIcon />
          <CustomDatePicker
            selected={date}
            onChange={onChangeDate}
            minDate={minDate}
            dateFormat="dd.MM.yyyy"
            placeholderText={datePlaceholder}
            monthsShown={1}
            popperProps={{ strategy: "fixed" }}
          />
        </div>
        {errorDate && <span className={style.error}>{errorDate}</span>}
      </div>

      <div className={style.col}>
        <span className={style.label}>
          {timeLabel}
          {required && <span className={style.required}> *</span>}
        </span>
        <div className={cn(style.control, { [style.controlError]: errorTime })}>
          <ClockIcon type={1} />
          <CustomDateTime
            selected={time}
            onChange={setTime}
            filterTime={filterPassedTime}
            placeholderText={timePlaceholder}
            popperProps={{ strategy: "fixed" }}
          />
        </div>
        {errorTime && <span className={style.error}>{errorTime}</span>}
      </div>
    </div>
  );
};

export default TenderDateTimePicker;
